import {useEffect} from 'react'
import clsx from 'clsx'
import { useSelector, shallowEqual } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'

import LoadingUser from '../../../../app/modules/loading/LoadingUser'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()

  const navigate = useNavigate();
  const location = useLocation();

  const { auth } = useSelector((state : any) => ({
    auth: state.auth,
  }), shallowEqual);

  return (
    <div className='app-navbar flex-shrink-0 justify-content-end'>
      {/*<div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTSVG path='/media/icons/duotune/general/gen032.svg' className={btnIconClass} />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTSVG path='/media/icons/duotune/general/gen022.svg' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>*/}

      {/* {config.app?.header?.default?.menu?.display && !auth.listLoading && auth.user && (
        <div className='app-navbar-item d-md-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-100 px-5 h-30px me-5 btn-custom'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={'svg-icon-primary svg-icon-2x'} />
          </div>
        </div>
      )} */}

      <div className={clsx('app-navbar-item', itemClass)}>
        {!auth.listLoading && !auth.user && <>
          <button
            className={`btn btn-primary w-100`}
            id="kt_subscriptions_create_button"
            onClick={() => navigate({}, { state: { login: location } })}
          >
            <span className="indicator-label">Entrar / Cadastro</span>
          </button>
        </>}


          {!auth.listLoading && auth.user && <>
            {!auth.user?.phone && <button
              type="submit"
              className="btn btn-sm btn-primary"
              style={{marginRight: '10px'}}
              onClick={() => navigate({}, { state: { verifyPhoneUrl: location } })}
            >
              <span className="indicator-label">
                Validar telefone
              </span>
            </button>}
          </>}

          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            {!auth.listLoading && auth.user && <>
              <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
            </>}
          </div>
          <HeaderUserMenu />

        {auth.listLoading && <LoadingUser />}
      </div>
    </div>
  )
}

export {Navbar}
